import React, { Fragment, useState, useEffect } from 'react'
import { API_URL } from '../../../utils/Constants/URLS'
import { useRef } from 'react'
import Select from 'react-select'
import Modal from 'react-bootstrap/Modal'
import { Col, Row } from 'reactstrap'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faTrashCan } from '@fortawesome/free-solid-svg-icons'
import { Toast } from 'primereact/toast'
import 'primereact/resources/themes/lara-light-cyan/theme.css'
import { useSelector } from 'react-redux'
import PageLoader from '../../../utils/PageLoader'

const EditSalesOrder = props => {
  const { info } = props

  const token = localStorage.getItem('token')
  const toast = useRef(null)
  const [productLineList, setProductLineList] = useState([])
  const [modelsList, setModelsList] = useState({})
  const [lineItems, setLineItems] = useState([])
  const [submitting, setSubmitting] = useState(false)
  const [showSuccessModal, setShowSuccessModal] = useState(false)
  const [showDeclineModal, setShowDeclineModal] = useState(false)
  const [modalMessage, setModalMessage] = useState('')
  const existingLineItems = useRef(0)
  const [zeroDateOfDelivery, setZeroOfDateDelivery] = useState('')
  const [customerPONumber, setCustomerPONumber] = useState('')
  const [customerPODate, setCustomerPODate] = useState('')
  const [gsplGSTNumber, setGsplGSTNumber] = useState('')
  const [remarks, setRemarks] = useState('')
  const [consultant, setConsultant] = useState('')
  const [currencyOfTransaction, setCurrencyOfTransaction] = useState('')
  const [checkShipping, setCheckShipping] = useState(false)
  const [billingAddress, setBillingAddress] = useState('')
  const [shippingAddress, setShippingAddress] = useState('')
  const [warrantyPeriod, setWarrantyPeriod] = useState('')
  const [committedDeliveryDate, setCommittedDeliveryDate] = useState('')
  const [stdLeadTime, setLeadTime] = useState('')
  const [warrantyTerms, setWarrantyTerms] = useState('')
  const [bankGuaranteeDetails, setbankGuaranteeDetails] = useState([])
  const [managerDetails, setManagerDetails] = useState([])
  const [manager, setManager] = useState('')
  const [typeOfTransaction, setTypeOfTransaction] = useState('')
  const [priceBasis, setPriceBasis] = useState('')
  const [isRejectedOrder, setIsRejectedOrder] = useState(false)
  const [responsibilityOfTransportation, setResponsibilityOfTransportation] =
    useState('')
  const [paymentTerms, setPaymentTerms] = useState([
    { type: '', percentage: '', amount: '', otherDetails: '' }
  ])
  const [isPOAvailable, setIsPoAvailable] = useState('true')
  const [PODetails, setPoDetails] = useState('')
  const [POFilePath, setPoFilePath] = useState('')
  const [BOMFilePath, setBOMFilePath] = useState('')
  const [bankGuaranteeDetailsPercent, setBankGuaranteeDetailsPercent] = useState('')
  const [finalOrderDocPath, setFinalOrderDocPath] = useState('')
  const poFileInputRef = useRef(null)
  const bomFileInputRef = useRef(null)
  const finalOrderDocInputRef = useRef(null)
  const userDetails = useSelector(store => store.user)
  const leadDetails = useSelector(store => store.deal)

  const bankGuaranteeDetailsData = [
    { value: 'NA', label: 'NA' },
    { value: 'ABG', label: 'ABG' },
    { value: 'CPBG', label: 'CPBG' },
    { value: 'PBG', label: 'PBG' }
  ]

  const handleCloseModal = () => {
    setShowSuccessModal(false)
    setShowDeclineModal(false)
    window.location.reload()
  }

  useEffect(() => {
    if (checkShipping) {
      setShippingAddress(billingAddress)
    }
  }, [checkShipping, billingAddress])

  useEffect(() => {
    if (info?.status === 'rejected') {
      setIsRejectedOrder(true)
    }
  }, [info])

  useEffect(() => {
    const fetchProductLine = async () => {
      try {
        const url = `${API_URL}product-lines?pagination=false&businessLine=${info?.lead?.businessLine?._id}`
        const res = await fetch(url, {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`
          }
        })
        const result = await res.json()
        setProductLineList(
          result.data.docs.map(item => ({
            value: item?.id,
            label: item?.productLineName
          }))
        )
      } catch (error) {
        console.error(error)
      }
    }

    fetchProductLine()
  }, [token])

  // Function to fetch models for a specific product line
  const fetchModelsForProductLine = async (productLineId) => {
    if (!productLineId) return []

    try {
      const url = `${API_URL}models?pagination=false&businessLine=${info?.lead?.businessLine?._id}&productLine=${productLineId}`
      const res = await fetch(url, {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`
        }
      })
      const result = await res.json()
      return result.data.docs.map(model => ({
        value: model._id,
        label: model.modelName + ' | ' + model.partCode
      }))
    } catch (error) {
      console.error('Error fetching models:', error)
      return []
    }
  }

  useEffect(() => {
    const fetchManagers = async () => {
      // Determine search parameter based on role
      const searchParam =
        userDetails?.role === 'executive' ? 'manager' : 'commercial_manager'

      const url = `${API_URL}users/org-contacts?pagination=false&search=${searchParam}`
      try {
        const response = await fetch(url, {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`
          }
        })
        const result = await response.json()
        setManagerDetails(
          result.data.docs.map(data => ({
            value: data._id,
            label: data.name
          }))
        )
      } catch (error) {
        console.error('Error fetching org contacts:', error)
      }
    }

    fetchManagers()
  }, [token, userDetails?.role])
  const uploadFiles = async () => {
    const poFileInput = poFileInputRef.current
    const bomFileInput = bomFileInputRef.current
    const finalOrderDocInput = finalOrderDocInputRef.current

    let uploadedPOPath = null
    let uploadedBOMPath = null
    let uploadedFinalOrderDocPath = null

    // Upload PO file if PO is available and file is selected
    if (isPOAvailable === 'true') {
      if (poFileInput && poFileInput.files && poFileInput.files.length > 0) {
        try {
          const myHeaders = new Headers()
          myHeaders.append('Authorization', `Bearer ${token}`)
          const formdata = new FormData()
          formdata.append('pdf', poFileInput.files[0])
          formdata.append('category', 'purchase-orders')

          const requestOptions = {
            method: 'POST',
            headers: myHeaders,
            body: formdata,
            redirect: 'follow'
          }

          const uploadRes = await fetch(`${API_URL}file/upload`, requestOptions)
          const uploadResult = await uploadRes.json()

          if (uploadResult && uploadResult.data) {
            if (typeof uploadResult.data === 'string') {
              uploadedPOPath = uploadResult.data
            } else if (uploadResult.data.filePath) {
              uploadedPOPath = uploadResult.data.filePath
            }
          }

          if (!uploadedPOPath) {
            toast.current.show({
              severity: 'error',
              summary: 'Error',
              detail: 'PO file upload failed',
              life: 3000
            })
            return null
          }

          setPoFilePath(uploadedPOPath)
        } catch (err) {
          toast.current.show({
            severity: 'error',
            summary: 'Error',
            detail: 'PO file upload failed',
            life: 3000
          })
          return null
        }
      }
    }

    // Upload BOM file if it's a Project and file is selected
    if (info?.lead?.productRequirements?.natureOfSale === 'Project') {
      if (bomFileInput && bomFileInput.files && bomFileInput.files.length > 0) {
        try {
          const myHeaders = new Headers()
          myHeaders.append('Authorization', `Bearer ${token}`)
          const formdata = new FormData()
          formdata.append('pdf', bomFileInput.files[0])
          formdata.append('category', 'bill-of-materials')

          const requestOptions = {
            method: 'POST',
            headers: myHeaders,
            body: formdata,
            redirect: 'follow'
          }

          const uploadRes = await fetch(`${API_URL}file/upload`, requestOptions)
          const uploadResult = await uploadRes.json()

          if (uploadResult && uploadResult.data) {
            if (typeof uploadResult.data === 'string') {
              uploadedBOMPath = uploadResult.data
            } else if (uploadResult.data.filePath) {
              uploadedBOMPath = uploadResult.data.filePath
            }
          }

          if (!uploadedBOMPath) {
            toast.current.show({
              severity: 'error',
              summary: 'Error',
              detail: 'BOM file upload failed',
              life: 3000
            })
            return null
          }

          setBOMFilePath(uploadedBOMPath)
        } catch (err) {
          toast.current.show({
            severity: 'error',
            summary: 'Error',
            detail: 'BOM file upload failed',
            life: 3000
          })
          return null
        }
      }
    }

    // Upload Final Order Doc (optional)
    if (
      finalOrderDocInput &&
      finalOrderDocInput.files &&
      finalOrderDocInput.files.length > 0
    ) {
      try {
        const myHeaders = new Headers()
        myHeaders.append('Authorization', `Bearer ${token}`)
        const formdata = new FormData()
        formdata.append('pdf', finalOrderDocInput.files[0])
        formdata.append('category', 'final-order-docs')

        const requestOptions = {
          method: 'POST',
          headers: myHeaders,
          body: formdata,
          redirect: 'follow'
        }

        const uploadRes = await fetch(`${API_URL}file/upload`, requestOptions)
        const uploadResult = await uploadRes.json()

        if (uploadResult && uploadResult.data) {
          if (typeof uploadResult.data === 'string') {
            uploadedFinalOrderDocPath = uploadResult.data
          } else if (uploadResult.data.filePath) {
            uploadedFinalOrderDocPath = uploadResult.data.filePath
          }
        }

        if (!uploadedFinalOrderDocPath) {
          toast.current.show({
            severity: 'error',
            summary: 'Error',
            detail: 'Final Order Doc upload failed',
            life: 3000
          })
          return null
        }

        setFinalOrderDocPath(uploadedFinalOrderDocPath)
      } catch (err) {
        toast.current.show({
          severity: 'error',
          summary: 'Error',
          detail: 'Final Order Doc upload failed',
          life: 3000
        })
        return null
      }
    }

    return { poPath: uploadedPOPath, bomPath: uploadedBOMPath, finalOrderDocPath: uploadedFinalOrderDocPath }
  }

  useEffect(() => {
    const transformedItems =
      info?.lineItems?.map((item, index) => {
        const model = item.model
        return {
          id: item._id || `existing-${index}`, // Add unique ID
          model: model?._id || '',
          productLine: model?.productLine?._id || '',
          quantity: item?.quantity || 0,
          listPrice: item?.listPrice || 0,
          discount: item?.discount || 0,
          rate: item?.rate || 0,
          value: item?.value || 0,
          standardLeadTime: item?.standardLeadTime || '',
          diQuantity: item?.diQuantity || 0,
          invoiceQuantity: item?.invoiceQuantity || 0,
          committedDeliveryDate:
            item?.committedDeliveryDate?.slice(0, 10) || '',
          isExisting: true
        }
      }) || []

    existingLineItems.current = transformedItems.length
    setLineItems(transformedItems)

    // Fetch models for existing product lines
    const fetchExistingModels = async () => {
      const uniqueProductLines = [...new Set(transformedItems.map(item => item.productLine).filter(Boolean))]
      const modelsData = {}

      for (const productLineId of uniqueProductLines) {
        const models = await fetchModelsForProductLine(productLineId)
        modelsData[productLineId] = models
      }

      setModelsList(modelsData)
    }

    if (transformedItems.length > 0) {
      fetchExistingModels()
    }

    // Populate paymentTerms from info
    if (info?.paymentTerms && Array.isArray(info.paymentTerms)) {
      const totalValue = info?.lineItems?.reduce(
        (acc, item) => acc + (item.value || 0),
        0
      )

      const mappedTerms = info.paymentTerms.map(term => {
        const percentage =
          totalValue > 0 ? ((term.amount / totalValue) * 100).toFixed(2) : '0'
        return {
          type: term.type || '',
          amount: term.amount?.toString() || '',
          percentage,
          otherDetails: term.otherDetails || ''
        }
      })

      setPaymentTerms(mappedTerms)
    } else {
      setPaymentTerms([{ type: '', percentage: '', amount: '' }])
    }

    // Prefill form fields
    if (info) {
      setZeroOfDateDelivery(info.zeroDateOfDelivery?.slice(0, 10) || '')
      setCustomerPONumber(info.customerPONumber || '')
      setCustomerPODate(info.customerPODate?.slice(0, 10) || '')
      setGsplGSTNumber(info.gsplGSTNumber || '')
      setConsultant(info.consultant || '')
      setCurrencyOfTransaction(info.currencyOfTransaction || '')
      setBillingAddress(info.billingAddress || '')
      setShippingAddress(info.shippingAddress || '')
      setWarrantyPeriod(info.warrantyPeriod || '')
      setWarrantyTerms(info.warrantyTerms || '')
      setbankGuaranteeDetails(
        info.bankGuaranteeDetails?.map(item => ({
          value: item,
          label: item
        })) || []
      )
      setTypeOfTransaction(info.typeOfTransaction || '')
      setPriceBasis(info.priceBasis || '')
      setResponsibilityOfTransportation(
        info.responsibilityOfTransportation || ''
      )
      setRemarks(info.remarks || '')

      // ADD THESE NEW FILE-RELATED FIELDS:
      setIsPoAvailable(info.isPOAvailable?.toString() || 'true')
      setPoDetails(info.PODetails || '')
      setPoFilePath(info.POFilePath || '')
      setBOMFilePath(info.BOMFilePath || '')
      setBankGuaranteeDetailsPercent(info.bankGuaranteeDetailsPercent || '')
      setFinalOrderDocPath(info.finalOrderDoc || '')

      // Set manager from existing approval data if available
      if (info.approvals && info.approvals.length > 0) {
        const latestApproval = info.approvals[info.approvals.length - 1]
        if (userDetails?.role === 'executive' && latestApproval.manager) {
          setManager(latestApproval.manager._id || latestApproval.manager)
        } else if (
          userDetails?.role !== 'executive' &&
          latestApproval.commercialManager
        ) {
          setManager(
            latestApproval.commercialManager._id ||
            latestApproval.commercialManager
          )
        }
      }
    }
  }, [info, userDetails?.role])

  useEffect(() => {
    const totalValue = lineItems.reduce(
      (acc, item) => acc + (parseFloat(item.value) || 0),
      0
    )

    // Only update percentage, preserve type & amount
    setPaymentTerms(prevTerms =>
      prevTerms.map(term => {
        const amount = parseFloat(term.amount) || 0
        const percentage =
          totalValue > 0 ? ((amount / totalValue) * 100).toFixed(2) : '0.00'
        return {
          ...term,
          percentage
        }
      })
    )
  }, [lineItems])

  const calculateAmtByQtyDisc = (listPrice, discount, qty) => {
    const price = parseFloat(listPrice) || 0
    const disc = parseFloat(discount) || 0
    const quantity = parseInt(qty) || 1
    const discountedPrice = Math.ceil(price - (disc / 100) * price)
    const finalVal = discountedPrice * quantity
    return { rate: discountedPrice, value: finalVal }
  }

  const calculateDiscountByAmt = (listPrice, enteredAmount, qty) => {
    const price = parseFloat(listPrice) || 0
    const amt = parseFloat(enteredAmount) || 0
    const quantity = parseInt(qty) || 1
    if (price === 0 || quantity === 0) return 0
    const unitPrice = amt / quantity
    return ((1 - unitPrice / price) * 100).toFixed(2)
  }

  const handleLineItemChange = async (index, field, value) => {
    const updatedItems = [...lineItems]
    const item = { ...updatedItems[index], [field]: value }

    // When product line changes, fetch models for that product line and clear model selection
    if (field === 'productLine') {
      item.model = '' // Clear model selection when product line changes
      item.listPrice = 0
      item.rate = 0
      item.value = 0

      // Fetch models for the selected product line
      const models = await fetchModelsForProductLine(value)
      setModelsList(prev => ({
        ...prev,
        [value]: models
      }))
    }

    if (field === 'model') {
      try {
        const res = await fetch(`${API_URL}models/${value}/batches/aggregate`, {
          method: 'GET',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`
          }
        })
        const result = await res.json()
        const listPrice = result?.data?.listPrice || 0
        item.listPrice = listPrice

        const qty = parseFloat(item.quantity || 0)
        const discount = parseFloat(item.discount || 0)
        const { rate, value: val } = calculateAmtByQtyDisc(
          listPrice,
          discount,
          qty
        )
        item.rate = rate
        item.value = val
      } catch (err) {
        console.error('Error fetching list price:', err)
      }
    }

    if (['quantity', 'listPrice', 'discount'].includes(field)) {
      const qty = parseFloat(field === 'quantity' ? value : item.quantity || 0)
      const price = parseFloat(
        field === 'listPrice' ? value : item.listPrice || 0
      )
      const discount = parseFloat(
        field === 'discount' ? value : item.discount || 0
      )
      const { rate, value: val } = calculateAmtByQtyDisc(price, discount, qty)
      item.rate = rate
      item.value = val
    }

    if (field === 'rate') {
      const rateNum = parseFloat(value) || 0
      const qty = parseFloat(item.quantity) || 1
      const price = parseFloat(item.listPrice) || 0

      item.value = rateNum * qty
      if (price !== 0) {
        item.discount = ((1 - rateNum / price) * 100).toFixed(2)
      } else {
        item.discount = 0
      }
    }

    if (field === 'value') {
      const qty = parseFloat(item.quantity || 0)
      const price = parseFloat(item.listPrice || 0)
      const enteredValue = parseFloat(value) || 0

      // Always calculate rate as value / quantity
      item.rate = qty > 0 ? Math.ceil(enteredValue / qty) : 0

      // Calculate discount based on listPrice if available
      if (price > 0) {
        item.discount = calculateDiscountByAmt(price, value, qty)
      } else {
        item.discount = 0
      }
    }


    updatedItems[index] = item
    setLineItems(updatedItems)
  }

  const addLineItem = () => {
    setLineItems([
      ...lineItems,
      {
        id: Date.now(), // Add unique ID for new items
        model: '',
        productLine: '',
        quantity: 0,
        listPrice: 0,
        discount: 0,
        rate: 0,
        value: 0,
        standardLeadTime: '',
        committedDeliveryDate: '',
        isExisting: false // Mark as new item
      }
    ])
  }

  const deleteLineItem = deleteIndex => {
    const updated = lineItems.filter((_, index) => index !== deleteIndex)
    setLineItems(updated)

    const newTotal = updated.reduce(
      (acc, item) => acc + (parseFloat(item.value) || 0),
      0
    )

    const updatedTerms = paymentTerms.map(term => {
      const amount = parseFloat(term.amount) || 0
      const percentage = newTotal ? ((amount / newTotal) * 100).toFixed(2) : '0'
      return {
        ...term,
        percentage
      }
    })

    setPaymentTerms(updatedTerms)
  }

  const assignManager = async (salesOrderId, method) => {
    try {
      // Determine the key name based on role
      const managerKey =
        userDetails?.role === 'executive' ? 'manager' : 'commercialManager'

      const res = await fetch(
        `${API_URL}leads/sales-orders/${salesOrderId}/approval/request`,
        {
          method: method, // Use the passed method parameter
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`
          },
          body: JSON.stringify({
            [managerKey]: manager
          })
        }
      )

      const response = await res.json()
      console.log('Manager assignment response:', response)
      return response
    } catch (error) {
      console.error('Error assigning manager:', error)
      throw error
    }
  }

  const handleSubmit = async e => {
    if (e) e.preventDefault()

    // client-side validations (same as your original checks)
    if (zeroDateOfDelivery === '') {
      toast.current?.show({
        severity: 'error',
        summary: 'Error',
        detail: 'Please Select Zero Date Delivery',
        life: 3000
      })
      return
    }

    if (gsplGSTNumber === '') {
      toast.current?.show({
        severity: 'error',
        summary: 'Error',
        detail: 'Please Select GSPL GST Number',
        life: 3000
      })
      return
    }

    if (currencyOfTransaction === '') {
      toast.current?.show({
        severity: 'error',
        summary: 'Error',
        detail: 'Please Select Currency of Transaction',
        life: 3000
      })
      return
    }

    if (warrantyPeriod === '') {
      toast.current?.show({
        severity: 'error',
        summary: 'Error',
        detail: 'Please Enter Warranty Period from Date of commissioning',
        life: 3000
      })
      return
    }

    if (warrantyTerms === '') {
      toast.current?.show({
        severity: 'error',
        summary: 'Error',
        detail: 'Please Enter Warranty Period from last date of supply',
        life: 3000
      })
      return
    }

    if (responsibilityOfTransportation === '') {
      toast.current?.show({
        severity: 'error',
        summary: 'Error',
        detail: 'Please Select Responsibility of Transportation',
        life: 3000
      })
      return
    }

    if (typeOfTransaction === '') {
      toast.current?.show({
        severity: 'error',
        summary: 'Error',
        detail: 'Please Select Type of Transaction',
        life: 3000
      })
      return
    }

    if (bankGuaranteeDetails.length === 0) {
      toast.current?.show({
        severity: 'error',
        summary: 'Error',
        detail: 'Please Select Bank Guarantee Details',
        life: 3000
      })
      return
    }

    if (billingAddress === '') {
      toast.current?.show({
        severity: 'error',
        summary: 'Error',
        detail: 'Please Enter Billing Address',
        life: 3000
      })
      return
    }

    if (!checkShipping && shippingAddress === '') {
      toast.current?.show({
        severity: 'error',
        summary: 'Error',
        detail: 'Please Enter Shipping Address',
        life: 3000
      })
      return
    }

    if (priceBasis === '') {
      toast.current?.show({
        severity: 'error',
        summary: 'Error',
        detail: 'Please Select Price Basis',
        life: 3000
      })
      return
    }

    // Validate manager selection
    if (!manager || manager === '') {
      const managerType =
        userDetails?.role === 'executive' ? 'Manager' : 'Commercial Manager'
      toast.current?.show({
        severity: 'error',
        summary: 'Error',
        detail: `Please Select a ${managerType}`,
        life: 3000
      })
      return
    }

    // Validate line items
    for (let i = 0; i < lineItems.length; i++) {
      const item = lineItems[i]
      if (!item.quantity || Number(item.quantity) <= 0) {
        toast.current?.show({
          severity: 'error',
          summary: 'Error',
          detail: `Line Item ${i + 1}: QTY must be greater than 0`,
          life: 3000
        })
        return
      }
      if (!item.rate || Number(item.rate) <= 0) {
        toast.current?.show({
          severity: 'error',
          summary: 'Error',
          detail: `Line Item ${i + 1}: Rate must be greater than 0`,
          life: 3000
        })
        return
      }
    }

    // Validate paymentTerms entries
    for (let i = 0; i < paymentTerms.length; i++) {
      const term = paymentTerms[i]
      if (
        !term.type ||
        term.type === '' ||
        term.percentage === '' ||
        term.amount === ''
      ) {
        toast.current?.show({
          severity: 'error',
          summary: 'Error',
          detail: `Please complete all fields in Payment Term ${i + 1}`,
          life: 3000
        })
        return
      }
    }

    // Validate total percentage == 100.00 (strict to 2 decimal places)
    const totalPercentageRaw = paymentTerms.reduce(
      (acc, term) => acc + (parseFloat(term.percentage) || 0),
      0
    )
    const totalPercentage = Math.round(totalPercentageRaw * 100) / 100
    if (totalPercentage !== 100) {
      toast.current?.show({
        severity: 'error',
        summary: 'Error',
        detail: `Total Payment Terms percentage must be exactly 100%. Currently it is ${totalPercentage.toFixed(
          2
        )}%.`,
        life: 4000
      })
      return
    }

    let poDetailsToSend = undefined

    if (isPOAvailable === 'true') {
      // Validate PO fields
      if (customerPONumber === '') {
        toast.current?.show({
          severity: 'error',
          summary: 'Error',
          detail: 'Please Enter Customer PO Number',
          life: 3000
        })
        return
      }
      if (customerPODate === '') {
        toast.current?.show({
          severity: 'error',
          summary: 'Error',
          detail: 'Please Select Customer PO Date',
          life: 3000
        })
        return
      }

      // Check if PO file upload is required (only if no existing file)
      const poFileInput = poFileInputRef.current
      if (
        !POFilePath &&
        (!poFileInput || !poFileInput.files || poFileInput.files.length === 0)
      ) {
        toast.current?.show({
          severity: 'error',
          summary: 'Error',
          detail: 'Please upload PO file',
          life: 3000
        })
        return
      }
      poDetailsToSend = undefined
    } else {
      // If PO is not available, validate PO Details
      if (PODetails === '') {
        toast.current?.show({
          severity: 'error',
          summary: 'Error',
          detail: 'Please Enter PO Details',
          life: 3000
        })
        return
      }

      // Warn if PO number, PO date, or PO file is entered
      if (
        customerPONumber !== '' ||
        customerPODate !== '' ||
        (poFileInputRef.current &&
          poFileInputRef.current.files &&
          poFileInputRef.current.files.length > 0)
      ) {
        toast.current?.show({
          severity: 'warn',
          summary: 'Warning',
          detail:
            'PO Number, PO Date, and PO File should not be entered when PO is not available.',
          life: 5000
        })
        return
      }
      poDetailsToSend = PODetails
    }

    // Validate BOM file upload for Project type (only require if no existing BOM path)
    if (info?.lead?.productRequirements?.natureOfSale === 'Project') {
      const bomFileInput = bomFileInputRef.current
      if (
        !BOMFilePath &&
        (!bomFileInput ||
          !bomFileInput.files ||
          bomFileInput.files.length === 0)
      ) {
        toast.current?.show({
          severity: 'error',
          summary: 'Error',
          detail: 'Please upload BOM file for Project type',
          life: 3000
        })
        return
      }
    }

    // All validations passed — show loader and perform network calls
    setSubmitting(true)

    try {
      // Upload files (both PO and BOM). uploadFiles returns { poPath, bomPath } or null on failure.
      const uploadResults = await uploadFiles()
      if (uploadResults === null) {
        // uploadFiles already showed a toast; return early (finally will clear submitting)
        return
      }

      const { poPath, bomPath, finalOrderDocPath: uploadedFinalDocPath } = uploadResults || {}

      // For PO available case, ensure PO was uploaded successfully (if no existing POFilePath)
      if (isPOAvailable === 'true' && !POFilePath && !poPath) {
        toast.current?.show({
          severity: 'error',
          summary: 'Error',
          detail: 'PO file upload failed',
          life: 3000
        })
        return
      }

      // For Project type, ensure BOM was uploaded successfully (if no existing BOMFilePath)
      if (
        info?.lead?.productRequirements?.natureOfSale === 'Project' &&
        !BOMFilePath &&
        !bomPath
      ) {
        toast.current?.show({
          severity: 'error',
          summary: 'Error',
          detail: 'BOM file upload failed',
          life: 3000
        })
        return
      }

      // Build sales order payload
      const salesOrderData = {
        lead: info?.lead || '',
        committedDeliveryDate,
        stdLeadTime,
        businessLine: info?.businessLine || '',
        lineItems,
        version: info?.version || '',
        dateOfSO: info?.dateOfSO || '',
        zeroDateOfDelivery,
        customerPONumber,
        customerPODate,
        gsplGSTNumber,
        consultant,
        currencyOfTransaction,
        billingAddress,
        shippingAddress,
        remarks,
        warrantyPeriod,
        warrantyTerms,
        bankGuaranteeDetails: bankGuaranteeDetails.map(item => item.value),
        bankGuaranteeDetailsPercent,
        typeOfTransaction,
        responsibilityOfTransportation,
        priceBasis,
        igst: info?.igst || 0,
        cgst: info?.cgst || 0,
        sgst: info?.sgst || 0,
        paymentTerms: paymentTerms.map(term => ({
          type: term.type,
          percentage: Number(term.percentage),
          amount: Number(term.amount),
          otherDetails: term.otherDetails || ''
        })),
        POFilePath: poPath ? poPath : POFilePath, // prefer new upload
        PODetails: poDetailsToSend,
        isPOAvailable,
        finalOrderDoc: uploadedFinalDocPath ? uploadedFinalDocPath : (finalOrderDocPath || null)
      }

      // Add BOM path if applicable
      if (info?.lead?.productRequirements?.natureOfSale === 'Project') {
        salesOrderData.BOMFilePath = bomPath || BOMFilePath
      }

      // If previously rejected, set status back to pending
      if (isRejectedOrder) {
        salesOrderData.status = 'pending'
      }

      // Determine method & url
      const method = isRejectedOrder ? 'PATCH' : 'POST'
      const url = isRejectedOrder
        ? `${API_URL}leads/sales-orders/${info?._id}`
        : `${API_URL}leads/sales-orders`

      // Create / update sales order
      const res = await fetch(url, {
        method,
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`
        },
        body: JSON.stringify(salesOrderData)
      })

      // network-level check
      if (!res.ok) {
        // Try to parse error body if possible
        let errBody = ''
        try {
          const errJson = await res.json()
          errBody = errJson?.message || JSON.stringify(errJson)
        } catch (parseErr) {
          errBody = res.statusText || `Status ${res.status}`
        }
        throw new Error(`Server Error: ${errBody}`)
      }

      const response = await res.json()

      if (response.error === false) {
        // Determine ID for manager assignment
        const salesOrderId = isRejectedOrder
          ? info?._id
          : response?.data?._id || response?.data?.id

        if (salesOrderId) {
          try {
            await assignManager(salesOrderId, method)

            const successMessage = isRejectedOrder
              ? 'Sales Order Updated and Manager Assigned Successfully. Please wait for approval'
              : 'Sales Order Updated and Manager Assigned Successfully Please Wait for Approval'

            setModalMessage(successMessage)
            setShowSuccessModal(true)
          } catch (managerError) {
            console.error('Manager assignment failed:', managerError)
            const errorMessage = isRejectedOrder
              ? 'Sales Order Updated but Manager Assignment Failed'
              : 'Sales Order Updated but Manager Assignment Failed'

            setModalMessage(errorMessage)
            setShowDeclineModal(true)
          }
        } else {
          setModalMessage(
            'Sales Order Updated but Missing ID for Manager Assignment'
          )
          setShowDeclineModal(true)
        }
      } else {
        setModalMessage('Failed to Update Sales Order')
        setShowDeclineModal(true)
      }
    } catch (error) {
      setModalMessage(error.message)
      setShowDeclineModal(true)
    } finally {
      // always hide page loader
      setSubmitting(false)
    }
  }

  const handlePaymentTermChange = (index, updates) => {
    const updatedTerms = [...paymentTerms]
    const term = { ...updatedTerms[index], ...updates }

    const totalValue = lineItems.reduce(
      (acc, item) => acc + (parseFloat(item.value) || 0),
      0
    )

    if ('amount' in updates) {
      const amount = parseFloat(updates.amount) || 0
      term.percentage = totalValue
        ? ((amount / totalValue) * 100).toFixed(2)
        : '0'
    }

    if ('percentage' in updates) {
      const percentage = parseFloat(updates.percentage) || 0
      term.amount = totalValue
        ? ((percentage / 100) * totalValue).toFixed(2)
        : '0'
    }

    updatedTerms[index] = term
    setPaymentTerms(updatedTerms)
  }

  const addPaymentTerm = () => {
    setPaymentTerms([...paymentTerms, { type: '', percentage: '', amount: '', otherDetails: '' }])
  }
  const removePaymentTerm = index => {
    setPaymentTerms(prev => prev.filter((_, i) => i !== index))
  }

  return (
    <Fragment>
      <div className='relative'>
        {submitting && (
          <div className='absolute inset-0 z-50 flex items-center justify-center'>
            <PageLoader />
          </div>
        )}
        <form
          onSubmit={e => {
            e.preventDefault()
            handleSubmit()
          }}
        >
          <Row className='mb-2'>
            <div className={isPOAvailable === 'true' ? 'col-md-4' : 'col-md-6'}>
              <label for='name' className='form-label'>
                Zero Date Delivery <span className='text-danger'>*</span>
              </label>
              <input
                value={zeroDateOfDelivery}
                onChange={e => setZeroOfDateDelivery(e.target.value)}
                name='meetingDate'
                min='2022-01-01'
                max='2099-12-31'
                className='form-control'
                type='date'
                id='meetingDate'
                onClick={e => e.target.showPicker && e.target.showPicker()}
              />
            </div>
            <div className={isPOAvailable === 'true' ? 'col-md-4' : 'col-md-6'}>
              <label htmlFor='isPOAvailable' className='form-label'>
                Is PO Available? <span className='text-danger'>*</span>
              </label>
              <select
                id='isPOAvailable'
                value={isPOAvailable}
                onChange={e => setIsPoAvailable(e.target.value)}
                className='form-select'
                required
              >
                <option value='true'>Yes</option>
                <option value='false'>No</option>
              </select>
            </div>
            {isPOAvailable === 'true' ? (
              <>
                <div className='col-md-4'>
                  <label htmlFor='name' className='form-label'>
                    Customer PO Number <span className='text-danger'>*</span>
                  </label>
                  <input
                    value={customerPONumber}
                    onChange={e => setCustomerPONumber(e.target.value)}
                    type='text'
                    className='form-control'
                    required
                  />
                </div>
                <div className='col-md-12'>
                  <label htmlFor='name' className='form-label'>
                    Upload PO <span className='text-danger'>*</span>
                  </label>
                  <input
                    ref={poFileInputRef}
                    type='file'
                    className='form-control'
                    accept='.pdf,.doc,.docx'
                  />
                </div>
                <div className='col-md-4'>
                  <label for='name' className='form-label'>
                    Customer PO Date <span className='text-danger'>*</span>
                  </label>
                  <input
                    value={customerPODate}
                    onChange={e => setCustomerPODate(e.target.value)}
                    name='meetingDate'
                    min='2022-01-01'
                    max='2099-12-31'
                    className='form-control'
                    type='date'
                    id='op date'
                    onClick={e => e.target.showPicker && e.target.showPicker()}
                  />
                </div>
              </>
            ) : (
              <div className='col-md-8'>
                <label htmlFor='name' className='form-label'>
                  PO Details <span className='text-danger'>*</span>
                </label>
                <textarea
                  type='text'
                  value={PODetails}
                  onChange={e => setPoDetails(e.target.value)}
                  className='form-control'
                  required
                />
              </div>
            )}

            <div className='col-md-4'>
              <label htmlFor='name' className='form-label'>
                GSPL GSTIN <span className='text-danger'>*</span>
              </label>
              <select
                className='form-select'
                value={gsplGSTNumber}
                onChange={e => setGsplGSTNumber(e.target.value)}
              >
                <option value=''>Select</option>
                <option value='19AAECG1743K1ZG'>19AAECG1743K1ZG</option>
                <option value='18AAECG1743K1ZI'>18AAECG1743K1ZI</option>
              </select>
            </div>
            <div className='col-md-4'>
              <label htmlFor='name' className='form-label'>
                Consultant (If Any)
              </label>
              <input
                value={consultant}
                onChange={e => setConsultant(e.target.value)}
                type='text'
                className='form-control'
              />
            </div>
            <div className='col-md-4'>
              <label htmlFor='name' className='form-label'>
                Currency Of Transaction <span className='text-danger'>*</span>
              </label>
              <select
                className='form-select'
                value={currencyOfTransaction}
                onChange={e => setCurrencyOfTransaction(e.target.value)}
              >
                <option value=''>Select</option>
                <option value='INR'>INR</option>
                <option value='USD'>USD</option>
              </select>
            </div>

            <div className='col-md-4'>
              <label htmlFor='name' className='form-label'>
                Warranty Period (In Months){' '}
                <span className='text-danger'>*</span>
              </label>
              <input
                value={warrantyPeriod}
                onChange={e => setWarrantyPeriod(e.target.value)}
                type='number'
                className='form-control'
                required
              />
            </div>
            <div className='col-md-4'>
              <label htmlFor='name' className='form-label'>
                Price Basis <span className='text-danger'>*</span>
              </label>
              <select
                className='form-select'
                value={priceBasis}
                onChange={e => setPriceBasis(e.target.value)}
              >
                <option value=''>Select</option>
                <option value='Ex- Works Factory'>Ex- Works Factory</option>
                <option value='Ex- Vendor Works'>Ex- Vendor Works</option>
                <option value='FOR Site'>FOR Site</option>
                <option value='Ex- Godown Bardhaman'>Ex- Godown Bardhaman</option>
                <option value='Ex- Godown Kolkata'>Ex- Godown Kolkata</option>
                <option value='Ex- Godown Siliguri'>Ex- Godown Siliguri</option>
                <option value='Ex- Godown Guwahati'>Ex- Godown Guwahati</option>
              </select>
            </div>
            <div className='col-md-4'>
              <label htmlFor='name' className='form-label'>
                Responsibility of transportation{' '}
                <span className='text-danger'>*</span>
              </label>
              <select
                className='form-select'
                value={responsibilityOfTransportation}
                onChange={e =>
                  setResponsibilityOfTransportation(e.target.value)
                }
              >
                <option value=''>Select</option>
                <option value='GSPL'>GSPL</option>
                <option value='Customer'>Customer</option>
              </select>
            </div>
            <div className='col-md-4'>
              <label htmlFor='name' className='form-label'>
                Type of Transaction <span className='text-danger'>*</span>
              </label>
              <select
                className='form-select'
                value={typeOfTransaction}
                onChange={e => setTypeOfTransaction(e.target.value)}
              >
                <option value=''>Select</option>
                <option value='Domestic'>Domestic</option>
                <option value='Export'>Export</option>
                <option value='Indirect Export'>Indirect Export</option>
                <option value='EPCG'>EPCG</option>
                <option value='Tax exempted'>Tax exempted</option>
              </select>
            </div>
            <div className='col-md-4'>
              <label htmlFor='name' className='form-label'>
                Bank Guarantee Details <span className='text-danger'>*</span>
              </label>
              <Select
                value={bankGuaranteeDetails}
                options={bankGuaranteeDetailsData}
                onChange={selectedOptions =>
                  setbankGuaranteeDetails(
                    selectedOptions
                      ? selectedOptions.map(option => ({
                        value: option.value,
                        label: option.label
                      }))
                      : []
                  )
                }
                isMulti={true}
              />
            </div>
            <div className='col-md-4'>
              <label htmlFor='bankGuaranteeDetailsPercent' className='form-label'>
                Bank Guarantee Percent
              </label>
              <input
                id='bankGuaranteeDetailsPercent'
                type='text'
                value={bankGuaranteeDetailsPercent}
                onChange={e => setBankGuaranteeDetailsPercent(e.target.value)}
                className='form-control'
                placeholder='e.g. 10%'
              />
            </div>
            <div className='col-md-4'>
              <label htmlFor='name' className='form-label'>
                Warranty Terms <span className='text-danger'>*</span>
              </label>
              <input
                type='text'
                value={warrantyTerms}
                onChange={e => setWarrantyTerms(e.target.value)}
                className='form-control'
                required
              />
            </div>
            <div className='col-md-6'>
              <label htmlFor='name' className='form-label'>
                Billing Address <span className='text-danger'>*</span>
              </label>
              <textarea
                value={billingAddress}
                onChange={e => setBillingAddress(e.target.value)}
                type='text'
                className='form-control'
                required
              />
            </div>

            <div className='col-md-12'>
              <div className='form-check'>
                <input
                  className='form-check-input'
                  type='checkbox'
                  checked={checkShipping}
                  onChange={e => {
                    setCheckShipping(e.target.checked)
                    // When checkbox is checked, copy billing address to shipping address
                    if (e.target.checked) {
                      setShippingAddress(billingAddress)
                    } else {
                      // Optionally clear shipping address when unchecked
                      setShippingAddress('')
                    }
                  }}
                  id='flexCheckDefault'
                />
                <label className='form-check-label' htmlFor='flexCheckDefault'>
                  Shipping address same as billing address?
                </label>
              </div>
            </div>

            <div className='col-md-6'>
              <label htmlFor='name' className='form-label'>
                Shipping Address <span className='text-danger'>*</span>
              </label>
              <textarea
                value={checkShipping ? billingAddress : shippingAddress}
                onChange={e => {
                  // Only update shipping address state if checkbox is not checked
                  if (!checkShipping) {
                    setShippingAddress(e.target.value)
                  }
                }}
                type='text'
                className='form-control'
                disabled={checkShipping} // Disable editing when checkbox is checked
                required
              />
            </div>
            <div className='col-md-12'>
              <label htmlFor='name' className='form-label'>
                Remarks
              </label>
              <textarea
                value={remarks}
                onChange={e => setRemarks(e.target.value)}
                type='text'
                className='form-control'
              />
            </div>
            <div className='col-md-12'>
              <label htmlFor='finalOrderDoc' className='form-label'>
                Final Order Document (PDF)
              </label>
              <input
                id='finalOrderDoc'
                ref={finalOrderDocInputRef}
                type='file'
                accept='.pdf'
                className='form-control'
              />
              {finalOrderDocPath && (
                <small className='text-success d-block mt-1'>
                  Existing file saved. Upload a new file to replace it.
                </small>
              )}
              <small className='text-muted'>Optional — upload the final signed order document (PDF only).</small>
            </div>

            {/* BOM File Upload — shown only for Project type */}
            {info?.lead?.productRequirements?.natureOfSale === 'Project' && (
              <div className='col-md-12'>
                <label htmlFor='bomFile' className='form-label'>
                  BOM (Bill of Materials) <span className='text-danger'>*</span>
                </label>
                <input
                  id='bomFile'
                  ref={bomFileInputRef}
                  type='file'
                  className='form-control'
                  accept='.csv,.xlsx,.xls,.pdf,.doc,.docx'
                />
                {BOMFilePath && (
                  <small className='text-success d-block mt-1'>
                    Existing BOM file saved. Upload a new file to replace it.
                  </small>
                )}
                <small className='text-muted'>Upload the Bill of Materials for this project.</small>
              </div>
            )}
          </Row>
          {lineItems.map((item, index) => {
            const isReadOnly = item.isExisting || false

            return (
              <Row className='mb-3' key={item.id || index}>
                <div className='d-flex align-items-center justify-content-between mb-2'>
                  <h5 className='mb-0'>Line Item {index + 1}</h5>
                  <FontAwesomeIcon
                    icon={faTrashCan}
                    className='text-danger'
                    style={{ cursor: 'pointer' }}
                    onClick={() => deleteLineItem(index)}
                  />
                </div>

                <Col md={4}>
                  <label className='form-label'>
                    Product Line <span className='text-danger'>*</span>
                  </label>
                  <Select
                    options={productLineList}
                    placeholder='Select Product Line'
                    value={productLineList.find(
                      opt => opt.value === item.productLine
                    )}
                    onChange={e =>
                      handleLineItemChange(index, 'productLine', e.value)
                    }
                    isDisabled={isReadOnly}
                  />
                </Col>

                <Col md={4}>
                  <label className='form-label'>
                    Model <span className='text-danger'>*</span>
                  </label>
                  <Select
                    options={item.productLine ? (modelsList[item.productLine] || []) : []}
                    placeholder={item.productLine ? 'Select Model' : 'Select Product Line First'}
                    value={(item.productLine && modelsList[item.productLine]) ? modelsList[item.productLine].find(opt => opt.value === item.model) : null}
                    onChange={e =>
                      handleLineItemChange(index, 'model', e.value)
                    }
                    isDisabled={isReadOnly || !item.productLine}
                  />
                </Col>

                <Col md={4}>
                  <label className='form-label'>
                    QTY <span className='text-danger'>*</span>
                  </label>
                  <input
                    type='number'
                    value={item.quantity}
                    onWheel={e => e.target.blur()}
                    onChange={e =>
                      handleLineItemChange(index, 'quantity', e.target.value)
                    }
                    className='form-control'
                  />
                </Col>

                <Col md={4}>
                  <label className='form-label'>
                    List Price <span className='text-danger'>*</span>
                  </label>
                  <input
                    type='number'
                    onWheel={e => e.target.blur()}
                    value={item.listPrice}
                    className='form-control'
                    disabled
                  />
                </Col>

                <Col md={4}>
                  <label className='form-label'>
                    Rate <span className='text-danger'>*</span>
                  </label>
                  <input
                    type='number'
                    placeholder='Enter Rate'
                    onWheel={e => e.target.blur()}
                    value={item.rate}
                    className='form-control'
                    disabled={isReadOnly || !item.quantity || Number(item.quantity) <= 0}
                    onChange={e =>
                      handleLineItemChange(index, 'rate', e.target.value)
                    }
                    required
                  />
                </Col>

                <Col md={4}>
                  <label className='form-label'>
                    Discount (%) <span className='text-danger'>*</span>
                  </label>
                  <input
                    type='number'
                    onWheel={e => e.target.blur()}
                    value={item.discount}
                    className='form-control'
                    disabled={isReadOnly || !item.quantity || Number(item.quantity) <= 0}
                    onChange={e =>
                      handleLineItemChange(index, 'discount', e.target.value)
                    }
                  />
                </Col>

                <Col md={4}>
                  <label className='form-label'>
                    Amount <span className='text-danger'>*</span>
                  </label>
                  <input
                    type='number'
                    value={item.value}
                    onWheel={e => e.target.blur()}
                    onChange={e =>
                      handleLineItemChange(index, 'value', e.target.value)
                    }
                    className='form-control'
                    disabled={isReadOnly || !item.quantity || Number(item.quantity) <= 0}
                  />
                </Col>

                <Col md={4}>
                  <label className='form-label'>
                    Standard Lead Time <span className='text-danger'>*</span>
                  </label>
                  <div className='d-flex gap-2'>
                    <input
                      type='number'
                      placeholder='Enter Here'
                      className='form-control'
                      value={item.standardLeadTime?.split(' ')[0] || ''}
                      onWheel={e => e.target.blur()}
                      onChange={e =>
                        handleLineItemChange(
                          index,
                          'standardLeadTime',
                          `${e.target.value} ${item.standardLeadTime?.split(' ')[1] || ''
                          }`
                        )
                      }
                      disabled={isReadOnly}
                    />
                    <select
                      className='form-select'
                      style={{ maxWidth: '100px' }}
                      value={item.standardLeadTime?.split(' ')[1] || ''}
                      onChange={e =>
                        handleLineItemChange(
                          index,
                          'standardLeadTime',
                          `${item.standardLeadTime?.split(' ')[0] || ''} ${e.target.value
                          }`
                        )
                      }
                      disabled={isReadOnly}
                    >
                      <option value=''>Select</option>
                      <option value='Days'>Days</option>
                      <option value='Weeks'>Weeks</option>
                      <option value='Months'>Months</option>
                    </select>
                  </div>
                </Col>

                <Col md={4}>
                  <label className='form-label'>
                    Committed Delivery Date{' '}
                    <span className='text-danger'>*</span>
                  </label>
                  <input
                    type='date'
                    value={item.committedDeliveryDate}
                    onChange={e =>
                      handleLineItemChange(
                        index,
                        'committedDeliveryDate',
                        e.target.value
                      )
                    }
                    className='form-control'
                    disabled={isReadOnly}
                  />
                </Col>
              </Row>
            )
          })}

          <div className='mt-3 mb-3'>
            <button
              type='button'
              onClick={addLineItem}
              className='btn btn-sm btn-secondary me-2'
            >
              + Add Item
            </button>
          </div>

          {/* Payment Terms */}
          <Row className='mb-3'>
            <Col xs={12}>
              <h4 className='text-lg font-semibold mb-3'>Payment Terms</h4>
            </Col>

            {paymentTerms.map((term, index) => (
              <Fragment key={index}>
                <Col xs={12} md={5} className='mb-3'>
                  <label className='form-label'>
                    Payment Type <span className='text-danger'>*</span>
                  </label>
                  <select
                    className='form-select'
                    value={term.type}
                    onChange={e => {
                      const newType = e.target.value
                      handlePaymentTermChange(index, {
                        type: newType,
                        ...(newType !== 'Others' ? { otherDetails: '' } : {})
                      })
                    }}
                  >
                    <option value=''>Select</option>
                    <option value='Advance along with Purchase order'>Advance along with Purchase order</option>
                    <option value='Payment against submission of drawings'>Payment against submission of drawings</option>
                    <option value='Payment against proof of placement of Purchase order to vendor'>
                      Payment against proof of placement of Purchase order to
                      vendor
                    </option>
                    <option value='Payment against pro-forma invoice before despatch along with 100% GST'>
                      Payment against pro-forma invoice before despatch along
                      with 100% GST
                    </option>
                    <option value='Payment against pro-forma invoice before despatch along with prorata GST'>
                      Payment against pro-forma invoice before despatch along
                      with prorata GST
                    </option>
                    <option value='Payment against despatch document'>Payment against despatch document</option>
                    <option value='Payment on receipt of material at site'>Payment on receipt of material at site</option>
                    <option value='Payment on stage completion of erection'>Payment on stage completion of erection</option>
                    <option value='Payment against completion of erection'>Payment against completion of erection</option>
                    <option value='Payment against completion of commissioning'>Payment against completion of commissioning</option>
                    <option value='Payment on completion of DLP'>Payment on completion of DLP</option>
                    <option value='Payment within 7/15/21/30/45/60/90 days from date of receipt of material'>
                      Payment within 7/15/21/30/45/60/90 days from date of
                      receipt of material
                    </option>
                    <option value='Others'>Others</option>
                  </select>
                </Col>

                <Col xs={12} md={2} className='mb-3'>
                  <label className='form-label'>
                    Percentage <span className='text-danger'>*</span>
                  </label>
                  <input
                    type='number'
                    className='form-control'
                    onWheel={e => e.target.blur()}
                    value={term.percentage}
                    onChange={e => handlePaymentTermChange(index, { percentage: e.target.value })}
                  />
                </Col>

                <Col xs={12} md={2} className='mb-3'>
                  <label className='form-label'>
                    Amount <span className='text-danger'>*</span>
                  </label>
                  <input
                    type='number'
                    className='form-control'
                    onWheel={e => e.target.blur()}
                    value={term.amount}
                    onChange={e => handlePaymentTermChange(index, { amount: e.target.value })}
                  />
                </Col>

                {term.type === 'Others' && (
                  <Col xs={12} md={2} className='mb-3'>
                    <label className='form-label'>
                      Other Details <span className='text-danger'>*</span>
                    </label>
                    <input
                      type='text'
                      className='form-control'
                      value={term.otherDetails || ''}
                      onChange={e => handlePaymentTermChange(index, { otherDetails: e.target.value })}
                      placeholder='Please specify'
                    />
                  </Col>
                )}

                <Col
                  xs={12}
                  md={1}
                  className='mb-3 d-flex align-items-end justify-content-center gap-2'
                >
                  {/* Add Button */}
                  <button
                    type='button'
                    className='btn add-btn text-white d-flex justify-content-center align-items-center'
                    onClick={addPaymentTerm}
                  >
                    +
                  </button>

                  {/* Delete Button → only visible from index 1 */}
                  {index > 0 && (
                    <button
                      type='button'
                      className='btn btn-danger d-flex justify-content-center align-items-center'
                      onClick={() => removePaymentTerm(index)}
                    >
                      -
                    </button>
                  )}
                </Col>
              </Fragment>
            ))}
          </Row>

          <div className='col-md-6'>
            <label htmlFor='name' className='form-label'>
              {userDetails?.role === 'executive'
                ? 'Select Manager'
                : 'Select Commercial Manager'}{' '}
              <span className='text-danger'>*</span>
            </label>
            <Select
              options={managerDetails}
              placeholder={
                userDetails?.role === 'executive'
                  ? 'Select Manager'
                  : 'Select Commercial Manager'
              }
              value={
                managerDetails.find(option => option.value === manager) || null
              }
              onChange={e => setManager(e ? e.value : '')}
              isClearable
            />
          </div>

          <div className='mt-3 mb-3 d-flex justify-content-end'>
            <button
              type='submit'
              className='btn btn-primary'
              disabled={submitting}
            >
              {submitting ? 'Updating...' : 'Update'}
            </button>
          </div>
        </form>
        <Modal show={showSuccessModal} centered>
          <Modal.Body>
            <div class='my-8 text-center'>
              <svg
                xmlns='http://www.w3.org/2000/svg'
                className='w-14 shrink-0 fill-green-500 inline'
                viewBox='0 0 512 512'
              >
                <path
                  d='M383.841 171.838c-7.881-8.31-21.02-8.676-29.343-.775L221.987 296.732l-63.204-64.893c-8.005-8.213-21.13-8.393-29.35-.387-8.213 7.998-8.386 21.137-.388 29.35l77.492 79.561a20.687 20.687 0 0 0 14.869 6.275 20.744 20.744 0 0 0 14.288-5.694l147.373-139.762c8.316-7.888 8.668-21.027.774-29.344z'
                  data-original='#000000'
                />
                <path
                  d='M256 0C114.84 0 0 114.84 0 256s114.84 256 256 256 256-114.84 256-256S397.16 0 256 0zm0 470.487c-118.265 0-214.487-96.214-214.487-214.487 0-118.265 96.221-214.487 214.487-214.487 118.272 0 214.487 96.221 214.487 214.487 0 118.272-96.215 214.487-214.487 214.487z'
                  data-original='#000000'
                />
              </svg>
              <h4 className='text-xl text-gray-800 font-semibold mt-4'>
                Good Job
              </h4>
              <p className='text-sm text-gray-500 leading-relaxed mt-4'>
                {modalMessage}!
              </p>
            </div>

            <button
              type='button'
              onClick={handleCloseModal}
              className='px-5 py-2.5 w-full rounded-lg text-white text-sm border-none outline-none bg-green-500 hover:bg-green-700'
            >
              Okay
            </button>
          </Modal.Body>
        </Modal>
        <Modal show={showDeclineModal} centered>
          <Modal.Body>
            <div className='my-8 text-center'>
              <svg
                xmlns='http://www.w3.org/2000/svg'
                className='w-14 fill-red-500 inline'
                viewBox='0 0 286.054 286.054'
              >
                <path
                  fill='#e2574c'
                  d='M143.027 0C64.04 0 0 64.04 0 143.027c0 78.996 64.04 143.027 143.027 143.027 78.996 0 143.027-64.022 143.027-143.027C286.054 64.04 222.022 0 143.027 0zm0 259.236c-64.183 0-116.209-52.026-116.209-116.209S78.844 26.818 143.027 26.818s116.209 52.026 116.209 116.209-52.026 116.209-116.209 116.209zm.009-196.51c-10.244 0-17.995 5.346-17.995 13.981v79.201c0 8.644 7.75 13.972 17.995 13.972 9.994 0 17.995-5.551 17.995-13.972V76.707c-.001-8.43-8.001-13.981-17.995-13.981zm0 124.997c-9.842 0-17.852 8.01-17.852 17.86 0 9.833 8.01 17.843 17.852 17.843s17.843-8.01 17.843-17.843c-.001-9.851-8.001-17.86-17.843-17.86z'
                  data-original='#e2574c'
                ></path>
              </svg>
              <h4 className='text-xl text-gray-800 font-semibold mt-4'>
                Error Occured
              </h4>
              <p className='text-sm text-gray-500 leading-relaxed mt-4'>
                {modalMessage}!
              </p>
            </div>

            <button
              type='button'
              onClick={handleCloseModal}
              className='px-5 py-2.5 w-full rounded-lg text-white text-sm border-none outline-none bg-red-500 hover:bg-red-700'
            >
              Okay
            </button>
          </Modal.Body>
        </Modal>
        <Toast ref={toast} />
      </div>
    </Fragment>
  )
}

export default EditSalesOrder
